import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from 'constants/ActionTypes';
import {
  FETCH_EXPORT_START,
  FETCH_EXPORT_SUCCESS,
  SET_WEB_USERS_API_PARAMS_OBJ,
  WEB_USERS_DATA,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  error: '',
  usersLoading: false,
  apiParamsObj: { sort: { column: 'created_at', sortType: 'DESC' } },
  usersCount: '',
  usersData: [],
  webUsersExportLoader: false,
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_START: {
      return {
        ...state,
        error: '',
        usersLoading: true,
      };
    }
    case FETCH_SUCCESS: {
      return {
        ...state,
        error: '',
        usersLoading: false,
      };
    }
    case SET_WEB_USERS_API_PARAMS_OBJ: {
      return {
        ...state,
        apiParamsObj: action.payload,
      };
    }
    case WEB_USERS_DATA: {
      return {
        ...state,
        error: '',
        usersCount: action.count,
        usersData: action.payload,
        usersLoading: false,
      };
    }

    case FETCH_ERROR: {
      return {
        ...state,
        error: action.payload,
        usersLoading: false,
      };
    }
    case FETCH_EXPORT_START: {
      return {
        ...state,
        error: '',
        webUsersExportLoader: true,
      };
    }
    case FETCH_EXPORT_SUCCESS: {
      return {
        ...state,
        error: '',
        webUsersExportLoader: false,
      };
    }
    default:
      return state;
  }
};
